//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { Card, Alert } from "react-bootstrap";

const AlertMessage = ({ alertMessage, alertType, showAlert }) => {

    const [show, setShow] = useState(true)

    useEffect(() => {
        const timeId = setTimeout(() => {
            setShow(false)
            showAlert()

        }, 5000)

        return () => {
            clearTimeout(timeId)
        }
    }, []);

    return (
        <div>
            {show ?
                <Card>
                    <Card.Body>
                        <Alert variant={alertType} onClose={() => showAlert()} dismissible>
                            <div className="alert-message">
                                <strong>{alertMessage}</strong>
                            </div>
                        </Alert>
                    </Card.Body>
                </Card>
                : ""
            }
        </div>
    )
};

export default AlertMessage;
